import React, { useEffect, useState } from 'react';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './qualifiedTm.css'
import QualifiedTmCard from './QualifiedTmCard';
import FullMenu from '../../../../main/components/fullmenu';

const QualifiedTm = () => {
    const [qfTeam, setQfTeamInfo] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.qualifiedTeam,
            })
            .then((response) => {
                const qfTeamDoc = response.data.allQualified_teams.edges[0].node;
                setQfTeamInfo(qfTeamDoc);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <>
            <section style={{ background: `url(${qfTeam?.section_bg?.url})` }} className="section-common-info  ">
                <div className="container">
                    <a className="text-decoration-none" href="/robotChallenge">
                        <h5 className="section-title pinter-cursor  pb-4" >
                            <FontAwesomeIcon icon={faChevronLeft} className="back-btn " />  Academic Initiatives
                        </h5>
                    </a>
                    <h3 className="subtitle pt-0 pb-1">{qfTeam?.title[0]?.text}</h3>



                    <div className="row g-2 pt-5">
                        {qfTeam?.card?.map(info => <QualifiedTmCard info={info}></QualifiedTmCard>)}


                    </div>

                </div>
            </section>

            <FullMenu />

        </>


    );
};

export default QualifiedTm;



